import React, { useState, useEffect } from "react";
import api from "../../../../Axios/api";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Pal from "../../../../themes/palette";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import MaterialTable from "material-table";
import DeleteCategory from "../../../FormDialog/DeleteCategory";
import {
  Select,
  MenuItem,
  Modal,
  Button,
  TextField,
  Container,
  Grid,
  Paper,
  Avatar,
  Typography,
} from "@material-ui/core";
import LibraryAddIcon from "@material-ui/icons/LibraryAdd";
import { Redirect } from "react-router-dom";
import { useUserContext } from "../../../../context/UserContext";
import useStyles from "./styles";

export default function AddSubCategoryProduct() {
  // Snackbar
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };

  const classes = useStyles();

  // context
  const { store } = useUserContext();
  const token = store.data.token;

  const [isLoggedOut, setIsLoggedOut] = useState(false);

  const [details, setDetails] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [vendorCategory, setVendorCategory] = useState([]);
  const [productCategory, setProductCategory] = useState([]);
  const [productSubCategory, setProductSubCategory] = useState([]);
  const [categoryDetails, setCategoryDetails] = useState({
    vendorName: "",
    vendorCategory: "",
    mainCategoryName: "",
    subCategoryName: "",
    subCategoryDescription: "",
  });

  const handleCategoryDetails = (input) => (e) => {
    setCategoryDetails({ ...categoryDetails, [input]: e.target.value });
  };
  const [IFerrors, setIFerrors] = useState({
    vendorNameError: "",
    vendorCategoryError: "",
    mainCategoryNameError: "",
    subCategoryNameError: "",
    subCategoryDescriptionError: "",
  });

  const resetInputFiels = () => {
    setCategoryDetails({
      vendorName: "",
      vendorCategory: "",
      mainCategoryName: "",
      subCategoryName: "",
      subCategoryDescription: "",
    });
  };

  const InputValidation = () => {
    const errors = {};
    var hasError = false;
    // name
    var nameFormat = /^[0-9A-Za-z\s_+()'#@&-]+$/;
    if (categoryDetails.subCategoryName.match(nameFormat)) {
      errors.subCategoryNameError = "";
    } else {
      hasError = true;
      errors.subCategoryNameError =
        "Invalid Input. Name cannot contains several Special Characters!";
    }

    // Product category
    if (categoryDetails.mainCategoryName.length === 0) {
      hasError = true;
      errors.mainCategoryNameError = "Please Choose a Category for Product!";
    } else {
      errors.mainCategoryNameError = "";
    }

    // Vendor category
    if (categoryDetails.vendorCategory.length === 0) {
      hasError = true;
      errors.vendorCategoryError =
        "Please Choose a Vendor Category to add Product!";
    } else {
      errors.vendorCategoryError = "";
    }

    // vendor List
    if (categoryDetails.vendorName.length === 0) {
      hasError = true;
      errors.vendorNameError = "Please Choose Vendor to add Product!";
    } else {
      errors.vendorNameError = "";
    }
    // description
    var descFormat = /^[A-Za-z0-9.,'!()#&+-\s]+$/;
    if (categoryDetails.subCategoryDescription.match(descFormat)) {
      errors.subCategoryDescriptionError = "";
    } else {
      hasError = true;
      errors.subCategoryDescriptionError =
        "Description contains several characters that aren't allowed!";
    }

    setIFerrors({ ...IFerrors, ...errors });
    return hasError;
  };
  const columns = [
    {
      title: "ID",
      field: "tableData.id",
      render: ({ tableData }) => <div>{tableData.id + 1}</div>,
      hidden: false,
      export: false,
    },
    {
      title: "Category Name",
      field: "mainCategoryName",
      hidden: false,
      export: true,
    },
    {
      title: "Description",
      field: "mainCategoryDescription",
    },
  ];

  // Edit Product Modal Settings here
  const [modalOpen, setModelOpen] = useState(false);
  const handleOpen = () => {
    setModelOpen(true);
  };
  const handleClose = () => {
    setModelOpen(false);
  };

  // Delete Product Dialog
  const [isDeletingProduct, setIsDeletingProduct] = useState(false);
  // show delete Account Dialog
  const handlerAccountDelete = () => {
    setIsDeletingProduct(true);
  };
  // Delete Subject Handler
  const confirmedDelete = () => {
    const categoryId = categoryDetails._id;

    // api to delete product
    api
      .delete(`/superAdmin/product/category/${categoryId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        // Removing deleted Product from details array
        const newDetails = details.filter((prod) => prod._id !== categoryId);
        setDetails(newDetails);
        setIsDeletingProduct(false);
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "SUCCESS: Product Sub-Category has been deleted!",
          open: true,
        });
      })
      .catch((error) => {
        setSnackBar({
          ...snackBarstate,
          type: "error",
          message: "ERROR: Something went wrong!",
          open: true,
        });
      });
  };

  const retrivingAllCategories = async () => {
    await api
      .get("/superAdmin/product/categories/view", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        // console.log("Product SubCategories are ", res.data.data.categories);
        setDetails(res.data.data.categories);
        let subC = details.map((el, index) =>
          console.log(
            "el.subcategories are",
            setProductSubCategory([...productSubCategory, el.subCategories])
          )
        );
        console.log("subcategories are ", productSubCategory);
      })

      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error.response.data.error))
      );
  };

  const getAllVendorCategory = async () => {
    // Parent Category
    api
      .get("/admin/vendorCategories", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const categoryList = res.data.data.categories;
        setVendorCategory(categoryList);
        console.log("Vendor Categories are", vendorCategory);
      })
      .catch((error) => console.log("Error: " + error));
  };

  const getVendorByCategory = async () => {
    if (categoryDetails.vendorCategory !== "") {
      await api
        .get(`/admin/vendors/${categoryDetails.vendorCategory}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          console.log("res is ", res.data.data);
          setVendorList(res.data.data.vendors);
          console.log("vendors are", vendorList);
        })
        .catch((error) => console.log("Error: " + error));
    }
  };

  const getProductCategoryByVendorNameAndCategory = async () => {
    const { vendorName } = categoryDetails;
    if (categoryDetails.vendorName !== "") {
      await api
        .post(
          "/superAdmin/categories/vendor/category",
          {
            vendorName,
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          console.log("Product Category of vendors are ", res.data.data);
          setProductCategory(res.data.data.categories);
          // console.log("product categories are ", vendorList);
        })
        .catch((error) => console.log("Error: " + error));
    }
  };

  const editCategoryHandler = (e) => {
    const categoryId = categoryDetails._id;
    e.preventDefault();

    api
      .patch(
        `/superAdmin/product/category/${categoryId}`,
        {
          ...categoryDetails,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        const newDetails = details.map((prod) =>
          prod._id === categoryId ? categoryDetails : prod
        );
        setDetails(newDetails);
        handleClose();
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "SUCCESS: Product Sub-Category has been Updated!",
          open: true,
        });
      })
      .catch(() => {
        handleClose();
        setSnackBar({
          ...snackBarstate,
          message: "ERROR: Something is not working properly!",
          type: "error",
          open: true,
        });
      });
  };

  const addProductSubCategoryHandler = (e) => {
    e.preventDefault();
    var hasError = InputValidation();
    if (hasError === false) {
      api
        .post(
          "/superAdmin/product/subCategory",
          {
            ...categoryDetails,
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          resetInputFiels();
          setSnackBar({
            ...snackBarstate,
            type: "success",
            message: "SUCCESS: Product Sub-Category Added Successfully!",
            open: true,
          });
          setTimeout(() => {
            window.location.reload();
          }, 10);
        })
        .catch((error) =>
          setSnackBar({
            ...snackBarstate,
            message: "ERROR: Fill all the fields first!!",
            type: "error",
            open: true,
          })
        );
    }
  };

  useEffect(() => {
    // Retriving List of Products from API
    retrivingAllCategories();
    // eslint-disable-next-line
    getAllVendorCategory();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getVendorByCategory();
    // eslint-disable-next-line
  }, [categoryDetails.vendorCategory]);

  useEffect(() => {
    getProductCategoryByVendorNameAndCategory();
    // eslint-disable-next-line
  }, [categoryDetails.vendorName]);

  return (
    <Grid container className={classes.root}>
      {isLoggedOut ? <Redirect to="/admin/login" /> : ""}
      <Grid item xs={12} sm={12} md={12} component={Paper}>
        <Container component="div" maxWidth="sm">
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LibraryAddIcon />
            </Avatar>
            <Typography variant="h5">Add Sub-Category For Product </Typography>
            <Grid className={classes.settingsSpacing}>
              <form className={classes.form}>
                <Select
                  variant="outlined"
                  margin="dense"
                  required
                  fullWidth
                  label="Sub Category"
                  style={{ marginTop: 8 }}
                  defaultValue={"DEFAULT"}
                  onChange={handleCategoryDetails("vendorCategory")}
                  error={IFerrors.vendorCategoryError.length > 0 ? true : false}
                >
                  <MenuItem value="DEFAULT" disabled>
                    Choose Vendor Category
                  </MenuItem>
                  {vendorCategory.map((el, index) => (
                    <MenuItem value={el.name} key={index}>
                      {el.name}
                    </MenuItem>
                  ))}
                </Select>

                <Select
                  variant="outlined"
                  margin="dense"
                  required
                  fullWidth
                  label="Vendor Name"
                  style={{ marginTop: 8 }}
                  defaultValue={"DEFAULT"}
                  onChange={handleCategoryDetails("vendorName")}
                  error={IFerrors.vendorNameError.length > 0 ? true : false}
                >
                  <MenuItem value="DEFAULT" disabled>
                    Choose Vendor
                  </MenuItem>
                  {vendorList.map((el, index) => (
                    <MenuItem value={el.companyName} key={index}>
                      {el.companyName}
                    </MenuItem>
                  ))}
                </Select>
                <Select
                  variant="outlined"
                  margin="dense"
                  required
                  fullWidth
                  label="Product Category"
                  style={{ marginTop: 8 }}
                  defaultValue={"DEFAULT"}
                  onChange={handleCategoryDetails("mainCategoryName")}
                  error={
                    IFerrors.mainCategoryNameError.length > 0 ? true : false
                  }
                >
                  <MenuItem value="DEFAULT" disabled>
                    Choose a Product Category
                  </MenuItem>
                  {productCategory.map((el, index) => (
                    <MenuItem value={el.mainCategoryName} key={index}>
                      {el.mainCategoryName}
                    </MenuItem>
                  ))}
                </Select>

                <TextField
                  variant="outlined"
                  margin="normal"
                  id="name"
                  label="Sub-Category Name"
                  name="name"
                  fullWidth
                  required
                  value={categoryDetails.subCategoryName}
                  onChange={handleCategoryDetails("subCategoryName")}
                  helperText={IFerrors.subCategoryNameError}
                  error={
                    IFerrors.subCategoryNameError.length > 0 ? true : false
                  }
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  id="description"
                  label="Sub-Category Description"
                  name="description"
                  required
                  value={categoryDetails.subCategoryDescription}
                  onChange={handleCategoryDetails("subCategoryDescription")}
                  helperText={IFerrors.subCategoryDescriptionError}
                  error={
                    IFerrors.subCategoryDescriptionError.length > 0
                      ? true
                      : false
                  }
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={addProductSubCategoryHandler}
                  className={classes.submit}
                >
                  Add Category
                </Button>
              </form>
            </Grid>
          </div>
        </Container>
        <Grid item xs={12} sm={12} md={12} component={Paper}>
          <MaterialTable
            style={{ width: 1000 }}
            title="All Categories"
            data={details}
            columns={columns}
            actions={[
              (rowData) => ({
                icon: () => <EditIcon />,
                tooltip: "Edit",
                onClick: (event, rowData) => {
                  setCategoryDetails(rowData);
                  handleOpen();
                },
              }),
              (rowData) => ({
                icon: () => <DeleteIcon />,
                tooltip: "Delete",
                onClick: (event, rowData) => {
                  setCategoryDetails(rowData);
                  handlerAccountDelete();
                },
              }),
            ]}
            options={{
              actionsColumnIndex: -1,
              headerStyle: {
                backgroundColor: Pal.palette.primary.main,
                color: "#fff",
                fontWeight: "bold",
              },
              exportButton: true,
              tableLayout: "auto",
            }}
            localization={{
              pagination: {
                labelRowsSelect: "Rows per page",
              },
            }}
          />
        </Grid>
        <Snackbar
          open={open}
          anchorOrigin={{ vertical, horizontal }}
          autoHideDuration={3000}
          onClose={handleCloseSnackBar}
          key={vertical + horizontal}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            onClose={handleCloseSnackBar}
            severity={snackBarstate.type}
          >
            {snackBarstate.message}
          </MuiAlert>
        </Snackbar>
      </Grid>

      <Modal
        open={modalOpen}
        onClose={handleClose}
        onBackdropClick={handleClose}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Container
          component={Paper}
          style={{
            padding: "20px",
            maxWidth: "50vw",
            maxHeight: "80vh",
            overflow: "auto",
            scrollbarWidth: "2px",
          }}
        >
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={12} align="center">
              <Typography variant="h5">Edit Category</Typography>
            </Grid>
            <form className={classes.form} noValidate style={{ padding: 20 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    autoFocus
                    margin="dense"
                    variant="outlined"
                    autoComplete="pName"
                    required
                    fullWidth
                    label="Name"
                    name="name"
                    value={categoryDetails.mainCategoryName}
                    onChange={handleCategoryDetails("mainCategoryName")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    multiline
                    rows={4}
                    label="Description"
                    value={categoryDetails.mainCategoryDescription}
                    onChange={handleCategoryDetails("mainCategoryDescription")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Select
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Vendor Name"
                    style={{ marginTop: 8 }}
                    defaultValue={"DEFAULT"}
                    value={categoryDetails.vendorName}
                    onChange={handleCategoryDetails("vendorName")}
                    error={IFerrors.vendorNameError.length > 0 ? true : false}
                  >
                    <MenuItem value="DEFAULT" disabled>
                      Choose Vendor
                    </MenuItem>
                    {vendorList.map((el, index) => (
                      <MenuItem value={el.companyName} key={index}>
                        {el.companyName}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={12}>
                  <Select
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Sub Category"
                    style={{ marginTop: 8 }}
                    defaultValue={"DEFAULT"}
                    value={categoryDetails.vendorCategory}
                    onChange={handleCategoryDetails("vendorCategory")}
                    error={
                      IFerrors.vendorCategoryError.length > 0 ? true : false
                    }
                  >
                    <MenuItem value="DEFAULT" disabled>
                      Choose Vendor Category
                    </MenuItem>
                    {vendorCategory.map((el, index) => (
                      <MenuItem value={el.name} key={index}>
                        {el.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                {/* SAVE CHANGES BUTTON */}
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  align="center"
                  style={{ margin: "20px 0" }}
                >
                  <Button
                    variant="outlined"
                    color="primary"
                    style={{ marginRight: 10 }}
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={editCategoryHandler}
                  >
                    Save Changes
                  </Button>
                </Grid>
              </Grid>

              <Snackbar
                open={open}
                anchorOrigin={{ vertical, horizontal }}
                autoHideDuration={3000}
                onClose={handleCloseSnackBar}
                key={vertical + horizontal}
              >
                <MuiAlert
                  elevation={6}
                  variant="filled"
                  onClose={handleCloseSnackBar}
                  severity={snackBarstate.type}
                >
                  {snackBarstate.message}
                </MuiAlert>
              </Snackbar>
            </form>
          </Grid>
        </Container>
      </Modal>

      {/* Delete Confirmation Dialog */}

      <DeleteCategory
        DeletingProduct={isDeletingProduct}
        setDeletingProduct={setIsDeletingProduct}
        confirmedDelete={confirmedDelete}
      />
    </Grid>
  );
}
